import { BlockchainAddress } from '~/store/blockchainAddresses/types'
import { ACCEPTED_CURRENCY, Blockchain } from '~/store/landing/types'
import { BANK_TRANSFER_NETWORK, BankAccount, WalletIdType } from '~/types'
import { TransferMethod } from '~/types/deposit'
import { TransferStateStatus } from '~/types/transfer'
import { FiatFee, StablecoinFee } from '~/types/withdraw'

export type StablecoinFeeTimer = {
  isRunning: boolean
  timeRemaining: number
}

export type State = {
  amount: string | null
  bankAccount: BankAccount | null
  bankNetwork: BANK_TRANSFER_NETWORK | null
  blockchainAddress: BlockchainAddress | null
  blockchainNetwork: Blockchain | null
  currency: ACCEPTED_CURRENCY | null
  error: string | null
  fiatFee: Partial<Record<ACCEPTED_CURRENCY, FiatFee>> | null
  stablecoinFee: StablecoinFee | null
  stablecoinFeeTimer: StablecoinFeeTimer
  status: TransferStateStatus
  transferMethod: TransferMethod | null
  walletId: WalletIdType
}

export enum WITHDRAW_ACTIONS {
  COUNTDOWN_STABLECOIN_FEE_TIMER = 'WITHDRAW_ACTIONS.COUNTDOWN_STABLECOIN_FEE_TIMER',
  RESET_WITHDRAW = 'WITHDRAW_ACTIONS.RESET_WITHDRAW',
  RESTART_STABLECOIN_FEE_TIMER = 'WITHDRAW_ACTIONS.RESTART_STABLECOIN_FEE_TIMER',
  SET_AMOUNT = 'WITHDRAW_ACTIONS.SET_AMOUNT',
  SET_BANK_ACCOUNT = 'WITHDRAW_ACTIONS.SET_BANK_ACCOUNT',
  SET_BANK_NETWORK = 'WITHDRAW_ACTIONS.SET_BANK_NETWORK',
  SET_BLOCKCHAIN_ADDRESS = 'WITHDRAW_ACTIONS.SET_BLOCKCHAIN_ADDRESS',
  SET_BLOCKCHAIN_NETWORK = 'WITHDRAW_ACTIONS.SET_BLOCKCHAIN_NETWORK',
  SET_CURRENCY = 'WITHDRAW_ACTIONS.SET_CURRENCY',
  SET_ERROR = 'WITHDRAW_ACTIONS.SET_ERROR',
  SET_FIAT_FEE = 'WITHDRAW_ACTIONS.SET_FIAT_FEE',
  SET_STABLECOIN_FEE = 'WITHDRAW_ACTIONS.SET_STABLECOIN_FEE',
  SET_STATUS = 'WITHDRAW_ACTIONS.SET_STATUS',
  SET_TRANSFER_METHOD = 'WITHDRAW_ACTIONS.SET_TRANSFER_METHOD',
  SET_WALLET_ID = 'WITHDRAW_ACTIONS.SET_WALLET_ID',
  START_STABLECOIN_FEE_TIMER = 'WITHDRAW_ACTIONS.START_STABLECOIN_FEE_TIMER',
  STOP_STABLECOIN_FEE_TIMER = 'WITHDRAW_ACTIONS.STOP_STABLECOIN_FEE_TIMER',
}

export type CountdownStablecoinFeeTimer = {
  type: typeof WITHDRAW_ACTIONS.COUNTDOWN_STABLECOIN_FEE_TIMER
  payload: number
}

export type ResetWithdraw = {
  type: typeof WITHDRAW_ACTIONS.RESET_WITHDRAW
}

export type RestartStablecoinFeeTimer = {
  type: typeof WITHDRAW_ACTIONS.RESTART_STABLECOIN_FEE_TIMER
}

export type SetAmount = {
  type: typeof WITHDRAW_ACTIONS.SET_AMOUNT
  payload: string | null
}

export type SetBankAccount = {
  type: typeof WITHDRAW_ACTIONS.SET_BANK_ACCOUNT
  payload: BankAccount | null
}

export type SetBankNetwork = {
  type: typeof WITHDRAW_ACTIONS.SET_BANK_NETWORK
  payload: BANK_TRANSFER_NETWORK | null
}

export type SetBlockchainAddress = {
  type: typeof WITHDRAW_ACTIONS.SET_BLOCKCHAIN_ADDRESS
  payload: BlockchainAddress | null
}

export type SetBlockchainNetwork = {
  type: typeof WITHDRAW_ACTIONS.SET_BLOCKCHAIN_NETWORK
  payload: Blockchain | null
}

export type SetCurrency = {
  type: typeof WITHDRAW_ACTIONS.SET_CURRENCY
  payload: ACCEPTED_CURRENCY | null
}

export type SetError = {
  type: typeof WITHDRAW_ACTIONS.SET_ERROR
  payload: string | null
}

export type SetFiatFee = {
  type: typeof WITHDRAW_ACTIONS.SET_FIAT_FEE
  payload: FiatFee | null
}

export type SetStablecoinFee = {
  type: typeof WITHDRAW_ACTIONS.SET_STABLECOIN_FEE
  payload: StablecoinFee | null
}

export type SetStatus = {
  type: typeof WITHDRAW_ACTIONS.SET_STATUS
  payload: TransferStateStatus
}

export type SetTransferMethod = {
  type: typeof WITHDRAW_ACTIONS.SET_TRANSFER_METHOD
  payload: TransferMethod | null
}

export type SetWalletId = {
  type: typeof WITHDRAW_ACTIONS.SET_WALLET_ID
  payload: WalletIdType
}

export type StartStablecoinFeeTimer = {
  type: typeof WITHDRAW_ACTIONS.START_STABLECOIN_FEE_TIMER
}

export type StopStablecoinFeeTimer = {
  type: typeof WITHDRAW_ACTIONS.STOP_STABLECOIN_FEE_TIMER
}

export type ActionTypes =
  | CountdownStablecoinFeeTimer
  | ResetWithdraw
  | RestartStablecoinFeeTimer
  | SetAmount
  | SetBankAccount
  | SetBankNetwork
  | SetBlockchainAddress
  | SetBlockchainNetwork
  | SetCurrency
  | SetError
  | SetFiatFee
  | SetStablecoinFee
  | SetStatus
  | SetTransferMethod
  | SetWalletId
  | StartStablecoinFeeTimer
  | StopStablecoinFeeTimer
